import './Card.scss';

import Icons, { IconSize } from '@pdcfrontendui/components/Icons';

import Badge from './Badge';
import Pill from './Pill';
import React from 'react';

type CardProps = {
  label: string;
  badge: number;
  newBadge: boolean;
  id?: string;
  children?: React.ReactNode;
  onClick: () => void;
};
const Card = ({ children, id, label, badge, newBadge, onClick }: CardProps) => {
  return (
    <button
      className="card"
      id={id}
      onClick={onClick}
      aria-label={`${label} ${badge} ulæste beskeder`}
    >
      <div>
        {children}
        {label}
        <Badge amount={badge} className="silent" />

        {newBadge && <Pill />}
      </div>
      <Icons.ChevronRight size={IconSize.XXXSmall} />
    </button>
  );
};
export default Card;
